import React, { useEffect } from "react"
import Container from "../Container/Container"
import './BlogList.scss';
import { Link, useStaticQuery, graphql } from "gatsby";
import Contact from "../Contact/Contact";
import AOS from 'aos';
import 'aos/dist/aos.css';

const BlogList = () => {

  useEffect(() => {
    AOS.init({
      offset: 120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 500, });
  }, []);

    const { allContentfulBlog } = useStaticQuery(graphql`
    {
      allContentfulBlog {
        nodes {
          createdAt(formatString: "MMMM Do, YYYY")
          id
          slug
          title
          overview
        }
      }
    }
  `);

  return (
    <>
      <Container>
      <div className="inner">
          <h1>Blog</h1>
          <div className="blog_boxes">
          {
            allContentfulBlog.nodes.map(node => (
                <div className="blog_box" key={node.id} data-aos="flip-down" data-aos-delay="500">
              <h1>{node.title}</h1>
              <p className="published">{node.createdAt}</p>
              <p>
                {node.overview}
              </p>
              <Link className="readmore" to={`/blog/${node.slug}`}>
                Read More
              </Link>
            </div>
            ))
          }
        
          </div>
          <div className="footer">
            <Contact />
            <span>
              Designed and Developed by Philane Msibi.{" "}
              {new Date().getFullYear()}
            </span>
          </div>
        </div>
      </Container>
    </>
  )
}

export default BlogList
